// ============================================================================
// FSA PRINT ENDPOINTS
// ============================================================================
// URL builders for the unified FS print engine.
// Backend controller: FsaPrintController → /api/v1/FsaPrint
//
// Per prima-web/CLAUDE.md Module Boundaries: FSA endpoints live under
// api/endpoints/fsa/ — never alongside basic-tier endpoints.

import { buildEndpoint, buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';
import type { FsAmountMode } from '../../types/fsa/print.types';

const BASE_PATH = '/FsaPrint';

export const fsaPrintEndpoints = {
  /**
   * GET /api/v1/FsaPrint/note/{engagementId}/{scheduleId}?mode=actual|rounded
   * Single-note preview PDF. Response: application/pdf binary.
   */
  singleNotePdf: (engagementId: ID, scheduleId: ID, mode: FsAmountMode) =>
    `${buildEndpointWithParams(`${BASE_PATH}/note/:engagementId/:scheduleId`, {
      engagementId,
      scheduleId,
    })}?mode=${mode}`,

  /**
   * POST /api/v1/FsaPrint/custom — full FsPrintSpec body. Reserved for
   * FSA-3 (statements + reports + signatories + section breaks).
   */
  custom: () => buildEndpoint(`${BASE_PATH}/custom`),

  basePath: () => BASE_PATH,
} as const;

export default fsaPrintEndpoints;
